import CheckboxInput from '@components/CheckboxInput'
import { ExplorerContext } from '@context/Explorer/context'
import { DewiBreakpointsLg } from '@furry/tokens'
import { Box, useTheme } from '@mui/material'
import { useSearchParams } from 'next/navigation'
import { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const OverviewCheckbox = ({ inModal = false }: { inModal?: boolean }) => {
  const { addFilterOption } = useContext(ExplorerContext)
  const { t } = useTranslation()
  const theme = useTheme()
  const params = useSearchParams()

  const checkboxInputData = useMemo(
    () => [
      {
        name: `${t('explorerPage.overview.form.legendary')}`,
        onChange: (value: boolean) => {
          addFilterOption('auraChecked', value)
        },
        initialValue: params.get('auraChecked') === 'true',
      },
    ],
    [params],
  )

  const sxStyles = inModal
    ? {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        width: '100%',
        border: 0,
        backgroundColor: 'transparent',

        text: {
          fontSize: '0.9rem',
          fontWeight: 'bold',
        },
      }
    : {
        text: {
          fontSize: '0.9rem',
        },
      }

  const boxStyled = inModal
    ? {
        [theme.breakpoints.up(parseInt(DewiBreakpointsLg))]: {
          display: 'none',
        },
      }
    : {
        [theme.breakpoints.down(parseInt(DewiBreakpointsLg))]: {
          display: 'none',
        },
      }
  return useMemo(
    () =>
      checkboxInputData.map((data) => (
        <Box
          key={data.name}
          paddingLeft={1}
          marginBottom={0}
          sx={{
            ...boxStyled,
          }}
        >
          <CheckboxInput
            sx={{ ...sxStyles }}
            label={data.name}
            onChange={data.onChange}
            initialValue={data.initialValue}
          />
        </Box>
      )),
    [checkboxInputData],
  )
}

export default OverviewCheckbox
